// Format a number as a whole-dollar currency string (e.g. 12870.5 → "$12,871").
// Distinct from `fCurrency` in formatNumber.js, which keeps two decimal
// places — billing reports render with whole-dollar precision by convention.
export const formatCurrency = (amount, currency = 'USD') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
